import styled from 'styled-components';
import { ReactComponent as RawArrowDownwardSVG } from '../../../../assets/icons/icon_arrow_downward.svg';

export const IconArrowDownward = styled(RawArrowDownwardSVG)``;
